import { Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SearchState } from '../../services/search.state';

@Component({
  selector: 'app-client-data',
  standalone: true,
  imports: [
    MatIconModule
  ],
  templateUrl: './client-data.component.html',
  styleUrl: './client-data.component.scss'
})
export class ClientDataComponent {
  readonly searchState = inject(SearchState);

  readonly clientName = computed(() => {
    const client = this.searchState.clientData();
    return client
      ? `${client.firstName || ''} ${client.lastName || ''}`.trim()
      : '';
  });

  readonly clientDocument = computed(() =>
    this.searchState.clientData()?.document ?? ''
  );

  readonly clientPhone = computed(() =>
    this.searchState.clientData()?.phone ?? ''
  );

  readonly clientEmail = computed(() =>
    this.searchState.clientData()?.email ?? ''
  );

  readonly isVip = computed(() =>
    this.searchState.clientData()?.isVip ?? false
  );
}
